import { type ReactNode } from 'react';

import { Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import BottomSheet from '@/designs-dev/device/BottomSheet';

/**
 * What a claim is, and the way into it, in a drawer a tap on its row opens.
 * One drawer for the results page and the profile's Assess tab, which show the
 * same claims.
 */
const ClaimSheet = ({
  name,
  about,
  start = 'Start filling it in',
  onStart,
  onClose,
  children,
}: {
  name: string;
  about: string;
  /** The button's label. */
  start?: string;
  onStart: () => void;
  onClose: () => void;
  /** Anything more about the claim, under what it is. */
  children?: ReactNode;
}) => (
  <BottomSheet
    title={name}
    variant='hug'
    onClose={onClose}
    footer={(close) => (
      <Button
        variant='primary'
        size='lg'
        isFullWidth
        ariaLabel={start}
        onPress={() => {
          close();
          onStart();
        }}
      >
        {start}
      </Button>
    )}
  >
    <Stack spacing={2.5}>
      <Typography variant='body1'>{about}</Typography>
      {children}
    </Stack>
  </BottomSheet>
);

export default ClaimSheet;
